<div class="sidenav-wrapper">
  <mat-nav-list>
    <img src="images/ad6-logo.png" alt="AD6 Logo" class="logo" />
    @if (user()) {
      @for (menuItem of menuItems(); track menuItem.code) {
        <mat-list-item (click)="onMenuItem(menuItem)">
          @if (menuItem.icon) {
            <mat-icon matListItemIcon>{{ menuItem.icon }}</mat-icon>
          }
          <span matListItemLine>{{ menuItem.label | translate }}</span>
        </mat-list-item>
      }
    } @else {
      <mat-list-item
        (click)="
          onMenuItem({
            code: 'start',
            label: 'general.label.start',
            data: ['start'],
            icon: 'home',
          })
        "
      >
        <mat-icon matListItemIcon>home</mat-icon>
        <span matListItemLine>{{ 'general.label.start' | translate }}</span>
      </mat-list-item>
    }
  </mat-nav-list>
  @if (user()) {
    <div class="sidenav-footer">
      <div class="sidebar-menu">
        <div class="sidebar-menu-item">
          <button [matMenuTriggerFor]="userMenu" class="sidebar-menu-button sidebar-menu-user-btn">
            <div class="sidebar-avatar">
              @if (userAvatar()) {
                <img [src]="userAvatar()" alt="User avatar" class="sidebar-avatar-image" />
              } @else {
                <span class="sidebar-avatar-fallback">{{ userName() ? userName()[0] : '?' }}</span>
              }
            </div>
            <div class="sidebar-title">
              <span class="sidebar-title-main">{{ userName() }}</span>
              <span class="sidebar-title-sub">{{ userEmail() }}</span>
            </div>
          </button>
          <mat-menu #userMenu="matMenu" yPosition="above">
            <div class="sidebar-menu-user-menu-header">
              <div class="sidebar-avatar sidebar-avatar-menu">
                @if (userAvatar()) {
                  <img [src]="userAvatar()" alt="User avatar" class="sidebar-avatar-image" />
                } @else {
                  <span class="sidebar-avatar-fallback">{{ userName() ? userName()[0] : '?' }}</span>
                }
              </div>
              <div class="sidebar-title">
                <span class="sidebar-title-main">{{ userName() }}</span>
                <span class="sidebar-title-sub">{{ userEmail() }}</span>
                @if (userRole()) {
                  <span class="sidebar-title-role">{{ userRole() | translate }}</span>
                }
              </div>
            </div>
            <button mat-menu-item (click)="auth.logout()">
              <mat-icon>logout</mat-icon>
              <span>{{ 'general.label.logout' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  }
</div>
